<div class="app-wizard-heading" role="tab">
  <ul class="app-wizard-steps nav nav-pills {{stepClass}}">
    <li (click)="onWizardHeaderClick($event, step)" *ngFor="let step of steps; let i = index"
      [attr.data-wizardstepid]="step.widgetId" [hidden]="!step.show"
      [ngClass]="{current: step.isActive, disabled: step.disabled}" class="app-wizard-step">
      <a>
        <span *ngIf="class && class.includes('classic')" class="arrow"></span>
        <span class="wizard-step-number">
          <span *ngIf="class && class.includes('number')" class="count">{{ i + 1 }}</span>
          <i *ngIf="class && (class.includes('dottedstepper') || class.includes('text-inline') && !class.includes('iconstepper'))"
            class="dottedstepper"></i>
          <i *ngIf="(class && class.includes('iconstepper')) && (step.iconclass)"
            class="app-icon {{step.iconclass}}"></i>
        </span>
        <span class="title-wrapper">
          <span *ngIf="class && class.includes('text-inline')">{{ '0' + (i + 1) }}</span>
          <span [textContent]="step.title" class="step-title"></span>
        </span>
        <span class="subtitle-wrapper" [attr.title]="step.subtitle" *ngIf="step.subtitle">
          <span class="step-title" [textContent]="step.subtitle"></span>
          <a class="read_more" style="display:none">more</a>
        </span>
      </a>
    </li>
  </ul>
</div>
<div class="app-wizard-body panel-body">
  <div wmsTransclude>
    <ng-content ngProjectAs="form[wmWizardstep]"></ng-content>
  </div>
</div>
@if (isRNapp) {
  <div class="app-wizard-actions panel-footer {{actionsalignment}}">
    <a class="app-wizard-skip" name="skipStep_{{name}}" *ngIf="currentStep?.enableskip" title="Skip step">Skip &raquo;</a>
    <div class="app-wizard-actions-right">
      <button type="button" name="cancelBtn_{{name}}" class="btn app-button btn-default" *ngIf="cancelable"
              [title]="cancelbtnlabel" [textContent]="cancelbtnlabel"></button>
      <button type="button" name="previousBtn_{{name}}" class="btn app-button btn-default" *ngIf="hasPrevStep">
        <i class="app-icon wi wi-chevron-left"></i>
        <span class="btn-caption" [textContent]="previousbtnlabel"></span>
      </button>
      <button type="button" name="nextBtn_{{name}}" class="btn app-button btn-primary" *ngIf="hasNextStep">
        <span class="btn-caption" [textContent]="nextbtnlabel"></span>
        <i class="app-icon wi wi-chevron-right"></i>
      </button>
      <button type="button" name="doneBtn_{{name}}" class="btn app-button btn-success" *ngIf="showDoneBtn">
        <i class="app-icon {{doneButtonIconClass}}"></i>
        <span class="btn-caption" [textContent]="donebtnlabel"></span>
      </button>
    </div>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="wizardAction"></ng-container>
}
